import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as moment from 'moment';
import { Link } from 'react-router';
import { imgSrcAttributes } from 'helpers/common';
require('./style.css');

interface IProps {
	section: IMagazinePageSection;
}

/* Component with 3 articles scattered around */
class ViewType7 extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { elements } = this.props.section.data;

		return (
			<div className="container sectionType7container">
				<div className="row">
					<div className="col-md-12 type7no_pad_fix">
						<div className="type7imageContainer image_top_right">
							<Link className="image" to={(elements[0] as ISectionImageElement).redirectUrl}>
								<div>
									<img {...imgSrcAttributes((elements[0] as ISectionImageElement).imageUrl)} />
								</div>
							</Link>
							<Link className="title" to={(elements[1] as ISectionTextElement).redirectUrl}>
								<span>{(elements[1] as ISectionTextElement).text}</span>
							</Link>
							<div className="info">
								<div className="author">{(elements[2] as ISectionTextElement).text}</div>
								<div className="date">{moment((elements[9] as ISectionTextElement).text).format('L')}</div>
								<div className="clear" />
							</div>
						</div>
						<div className="clear" />
						<div className="type7imageContainer image_middle_left">
							<Link className="image" to={(elements[3] as ISectionImageElement).redirectUrl}>
								<div>
									<img {...imgSrcAttributes((elements[3] as ISectionImageElement).imageUrl)} />
								</div>
							</Link>
							<Link className="title" to={(elements[4] as ISectionTextElement).redirectUrl}>
								<span>{(elements[4] as ISectionTextElement).text}</span>
							</Link>
							<div className="info">
								<div className="author">{(elements[5] as ISectionTextElement).text}</div>
								<div className="date">{moment((elements[10] as ISectionTextElement).text).format('L')}</div>
								<div className="clear" />
							</div>
						</div>
						<div className="clear" />
						<div className="type7imageContainer image_bottom_right">
							<Link className="image" to={(elements[6] as ISectionImageElement).redirectUrl}>
								<div>
									<img {...imgSrcAttributes((elements[6] as ISectionImageElement).imageUrl)} />
								</div>
							</Link>
							<Link className="title" to={(elements[7] as ISectionTextElement).redirectUrl}>
								<span>{(elements[7] as ISectionTextElement).text}</span>
							</Link>
							<div className="info">
								<div className="author">{(elements[8] as ISectionTextElement).text}</div>
								<div className="date">{moment((elements[11] as ISectionTextElement).text).format('L')}</div>
								<div className="clear" />
							</div>
						</div>
						<div className="clear" />
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType7 };
